import { CenteredLazyLoading } from "@/controls/CenteredLazyLoading";
import { CatalogGrade } from "@/pages/steel/models/CatalogGrade";
import { deleteCatalogGrade } from "@/pages/steel/repositories/CatalogGradeRepository";
import { ErrorModal, MesfModal } from "@dexteel/mesf-core";
import { Button } from "@material-ui/core";
import { Grid, Typography } from "@material-ui/core";
import React, { useState } from "react";

interface Props {
	show: "create" | "update" | "delete" | "";
	onHide: (shouldUpdate: boolean) => void;
	selectedRowData: CatalogGrade | null;
}

export const DeleteGradeModal = ({ show, onHide, selectedRowData }: Props) => {
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState("");

	const handleDelete = async () => {
		setIsLoading(true);
		const resp = await deleteCatalogGrade(selectedRowData?.GradeId!);
		if (!resp.ok) {
			setError(resp.message);
		}
		onHide(true);
		setIsLoading(false);
	};

	return (
		<>
			<MesfModal
				title={`DELETE GRADE`}
				open={show === "delete"}
				handleClose={() => onHide(false)}
				maxWidth="md"
			>
				<MesfModal.Content style={{ padding: "15px 30px" }} dividers>
					{isLoading && <CenteredLazyLoading />}
					{!isLoading && (
						<>
							<Grid container spacing={1}>
								<Grid item md={12} xs={12}>
									<Typography>
										Are you sure you want to delete{" "}
										<strong>{selectedRowData?.GradeName}</strong> grade?
									</Typography>
								</Grid>
							</Grid>
						</>
					)}
				</MesfModal.Content>
				<MesfModal.Actions style={{ padding: "20px 30px 30px" }}>
					<Grid container spacing={2} justifyContent="flex-end">
						<Grid item md={3} xs={12} style={{ margin: 0 }}>
							<Button
								fullWidth
								variant="contained"
								color="default"
								onClick={() => onHide(false)}
							>
								Cancel
							</Button>
						</Grid>
						<Grid item md={3} xs={12} style={{ margin: 0 }}>
							<Button
								fullWidth
								variant="contained"
								color="secondary"
								onClick={handleDelete}
							>
								DELETE
							</Button>
						</Grid>
					</Grid>
				</MesfModal.Actions>
			</MesfModal>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
